<template>
  <div
    id="scrollable"
    tabindex="0"
    aria-label="Page content"
    class="scrollbar flex grow flex-col overflow-y-auto pt-6 pr-4 pl-6">
    <!-- Content -->

    <slot />
    <div class="h-6 shrink-0 bg-transparent"></div>
  </div>
</template>

<style scoped>
/* Same quiet scrollbar as the chat panel's scroll area: transparent track, translucent slate thumb
   that darkens on hover. The old version painted a dark type-muted thumb and slate-100 track caps
   with margin offsets, which read as a foreign element on the redesigned surfaces. */
.scrollbar {
  scrollbar-color: color-mix(in srgb, var(--color-slate-400) 35%, transparent) transparent;
}

.scrollbar::-webkit-scrollbar {
  width: 10px;
}

.scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 9999px;
  background: color-mix(in srgb, var(--color-slate-400) 35%, transparent);
}

.scrollbar::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--color-slate-500) 55%, transparent);
}
</style>
